import React from "react";
import { useInput } from "react-admin";
import { FormControlLabel, Switch } from "@material-ui/core";

const GenerateArticleToggleField = ({ source, label, ...props }) => {
  const { input } = useInput({
    ...props,
    source,
    defaultValue: props.defaultValue || {}
  });
  
  const currentMetadata = input.value || {};
  const currentValue = currentMetadata.generate_article || false;
  
  const handleChange = (event) => {
    const newValue = event.target.checked;
    
    const newMetadata = {
      ...currentMetadata,
      generate_article: newValue
    };
    
    input.onChange(newMetadata);
  };

  return (
    <FormControlLabel
      control={
        <Switch
          checked={currentValue}
          onChange={handleChange}
          color="primary"
        />
      }
      label={label}
      {...props}
    />
  );
};

export default GenerateArticleToggleField;
